import { ComboBox } from '@components/combo-box'

customElements.define('kiss-combo-box', ComboBox)
